import { useLocation, useNavigate as useNavigateRouter } from 'react-router-dom'
import { useLinkQueryString, useLinkFilterQueryString } from 'hooks/useQueryString'

function useNavigate() {
  const navigateRouter = useNavigateRouter()

  function navigate(path, options) {
    navigateRouter(path, options)
  }

  function replace(path, options) {
    navigateRouter(path, { replace: true, ...options })
  }

  function goBack() {
    navigateRouter(-1)
  }

  return { navigate, replace, goBack }
}

export function useNavigateFrom() {
  const { navigate } = useNavigate()
  const { state: currentState } = useLocation()

  function navigateFrom(defaultPath, onNavigateFrom, extraState, options) {
    const path = currentState?.from ? { ...currentState.from } : { pathname: defaultPath }

    let state = currentState?.from ? { ...currentState.from.state, from: undefined } : currentState

    if (extraState) {
      state = { ...state, ...extraState }
    }

    navigate(path, { state, ...options })
    onNavigateFrom && onNavigateFrom(path)
  }

  return navigateFrom
}

export function useNavigateTo() {
  const { navigate } = useNavigate()
  const current = useLocation()

  function navigateTo(to, routeState = {}) {
    if (to.pathname) {
      navigate({ ...to }, { state: { from: current, ...to.state } })
    } else {
      navigate({ pathname: to }, { state: { from: current, ...routeState } })
    }
  }

  return navigateTo
}

export function useNavigateQueryString() {
  const { navigate } = useNavigate()
  const getLinkQueryString = useLinkQueryString()

  function navigateQueryString({ pathname, items }) {
    const link = getLinkQueryString({ pathname, items })
    navigate(link)
  }

  return navigateQueryString
}

export function useNavigateFilterQueryString() {
  const { navigate } = useNavigate()
  const getLinkFilterQueryString = useLinkFilterQueryString()

  function navigateFilterQueryString({ pathname, items }) {
    const link = getLinkFilterQueryString({ pathname, filters: items })
    navigate(link)
  }

  return navigateFilterQueryString
}

export default useNavigate
